const BrandPhilosophy = () => (
  <section
    className="bg-[#F6F1EA] py-16 sm:py-20 border-t border-[#D7B2A3]/30"
    data-testid="brand-philosophy-section"
  >
    <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
      <p className="text-xs tracking-eyebrow uppercase text-[#B89B63] mb-8">A promise</p>
      <blockquote
        className="font-serif text-3xl sm:text-4xl lg:text-[44px] text-[#4F5D4F] leading-[1.25] tracking-tight"
        data-testid="brand-philosophy-quote"
      >
        <span className="block">I won't tell you what to believe.</span>
        <span className="block mt-3 italic text-[#B89B63]">
          I'll help you create enough space to discover what you believe—
          <br className="hidden sm:block" />
          and trust yourself as you do.
        </span>
      </blockquote>
      <div className="mt-10 flex items-center justify-center">
        <div className="w-16 h-px bg-[#B89B63]" />
      </div>
      <p className="mt-6 text-xs tracking-eyebrow uppercase text-[#8C9A88]">— Jess Eisaman</p>
    </div>
  </section>
);

export default BrandPhilosophy;
